import { CanvasJSChart } from 'app/components/CanvasJs';
import React from 'react';
import { coresGraficoContasPagar } from './styles';

const GraficoSomatoriosContasPagar = ({ values }) => {
  return (
    <CanvasJSChart
      options={{
        culture: 'pt-br',
        animationEnabled: true,
        axisY: {
          prefix: 'R$',
          labelFontSize: 11,
        },
        toolTip: {
          shared: true,
        },
        legend: {
          fontSize: 16,
          cursor: 'pointer',
          verticalAlign: 'bottom',
        },
        data: [
          {
            type: 'pie',
            showInLegend: true,
            yValueFormatString: 'R$ ###,##0.00',
            indexLabel: '{label} - {y}',
            dataPoints: [
              {
                y: values.somatorioAVencer || 0,
                label: 'A vencer',
                color: coresGraficoContasPagar.azul,
                legendText: 'A vencer',
              },
              {
                y: values.somatorioBaixadas || 0,
                label: 'Baixadas',
                color: coresGraficoContasPagar.verde,
                legendText: 'Baixadas',
              },
              {
                y: values.somatorioParciais || 0,
                label: 'Parciais',
                color: coresGraficoContasPagar.laranja,
                legendText: 'Parciais',
              },
              {
                y: values.somatorioVencidas || 0,
                label: 'Atrasadas',
                color: coresGraficoContasPagar.vermelho,
                legendText: 'Atrasadas',
              },
            ],
          },
        ],
      }}
    />
  );
};

export default GraficoSomatoriosContasPagar;
